import {expenseConstants} from '../constants';

const expenseState = {
  addExpenseModalProps: {
    open: false,
  },
  duplicatesModalProps: {
    open: false,
    duplicateGroupId: null,
    expenseId: null,
    date: null,
  },
  expense: {},
};

const expenseReducer = (state = expenseState, action) => {
  const {type, data} = action;
  switch (type) {
    case expenseConstants.CLOSE_ADD_EXPENSE_MODAL:
      return {
        ...state,
        addExpenseModalProps: { ...state.addExpenseModalProps, open: false }
      }
    case expenseConstants.OPEN_ADD_EXPENSE_MODAL:
      return {
        ...state,
        addExpenseModalProps: { open: true, ...data }
      }
    case expenseConstants.OPEN_DUPLICATES_MODAL:
      return {
        ...state,
        duplicatesModalProps: { open: true, ...data }
      }
    case expenseConstants.CLOSE_DUPLICATES_MODAL:
      return {
        ...state,
        duplicatesModalProps: { open: false, duplicateGroupId: null, expenseId: null, date: null }
      }
    case expenseConstants.GET_EXPENSE:
      return {
        ...state,
        expense: data
      }
    case expenseConstants.CLEAR_EXPENSE_DATA:
      return {
        ...state,
        expense: expenseState.expense
      }
    default:
      return state;
  }
};

export default expenseReducer;
